'use client';

import React from 'react';
import classNames from 'classnames';

export interface SectionTitleWithIconProps {
  /** Icon component (e.g. ShieldIcon, MaternityIcon). Rendered at 24x24. */
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  children: React.ReactNode;
  className?: string;
}

/**
 * Section title with leading icon
 */
export const SectionTitleWithIcon: React.FC<SectionTitleWithIconProps> = ({
  icon: Icon,
  children,
  className,
}) => {
  return (
    <div
      className={classNames(
        'flex items-center gap-2 text-ds-title-s font-medium text-ds-text-4',
        className,
      )}
    >
      <Icon className="w-6 h-6 shrink-0 text-ds-text-4" aria-hidden />
      <span>{children}</span>
    </div>
  );
};

export default SectionTitleWithIcon;
